/**
 * Created by JackCui on 2021/1/13
 */

import * as formula from './formula'

const singleChoiceValue = (value) => {
  if (typeof value === 'number') {
    return value.toString()
  }
  return value
}
const lookupRelationship = (value) => {
  if (value && value.id) {
    return value.id
  }
  return value
}

/* eslint-disable */
/**
 * 操作符对应函数
 * @type {Object}
 */
export const symbolHandle = {
  'paas-shortText': {
    /**
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      return a === b
    },
    'ISNULL': formula.valueIsNull
  },
  'paas-singleChoice': {
    /**
     * @param a {object}
     * @param b {object}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      return singleChoiceValue(a) === singleChoiceValue(b)
    },
    /**
     * @param a {object}
     * @param b {object}
     * @return {boolean}
     */
    'BELONG': function (a, b) {
      return !!(b && b.find(item => singleChoiceValue(item) === singleChoiceValue(a)))
    },
    /**
     * @param a {object}
     * @param b {object}
     * @return {boolean}
     */
    'NO_BELONG': function (a, b) {
      return !(b && b.find(item => singleChoiceValue(item) === singleChoiceValue(a)))
    },
    'ISNULL': formula.valueIsNull
  },
  'paas-boole': {
    /**
     * @param a {object}
     * @param b {object}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      // TODO 处理编辑页选择的值为字符串
      const booleanMap = {
        'true': true,
        'false': false
      }
      if (typeof a === 'string' && booleanMap.hasOwnProperty(a)) {
        return booleanMap[a] === b
      }
      return a === b
    }
  },
  'paas-number': {
    /**
     * 等于
     * @param a {string}
     * @param b {number}
     * @return {boolean}
     */
    'EQUAL': formula.NUMBER_EQUAL,
    /**
     * 大于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'MORE_THAN': formula.NUMBER_MORE_THAN,
    /**
     * 大于等于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'NO_LESS_THAN': formula.NUMBER_NO_LESS_THAN,
    /**
     * 小于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'LESS_THAN': formula.NUMBER_LESS_THAN,
    /**
     * 小于等于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'NO_MORE_THAN': formula.NUMBER_NO_MORE_THAN,
    /**
     * 介于
     * @param a {string}
     * @param b {Array}
     * @return {boolean}
     */
    'BETWEEN': formula.NUMBER_BETWEEN,
    /**
     * 介于等于
     * @param a {string}
     * @param b {Array}
     * @return {boolean}
     */
    'BETWEEN_EQUAL': formula.NUMBER_BETWEEN_EQUAL,
    'ISNULL': formula.valueIsNull
  },
  'paas-currency': {
    /**
     * @param a {string,number}
     * @param b {number}
     * @return {boolean}
     */
    'EQUAL': formula.NUMBER_EQUAL,
    /**
     * 大于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'MORE_THAN': formula.NUMBER_MORE_THAN,
    /**
     * 大于等于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'NO_LESS_THAN': formula.NUMBER_NO_LESS_THAN,
    /**
     * 小于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'LESS_THAN': formula.NUMBER_LESS_THAN,
    /**
     * 小于等于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'NO_MORE_THAN': formula.NUMBER_NO_MORE_THAN,
    /**
     * 介于
     * @param a {string}
     * @param b {Array}
     * @return {boolean}
     */
    'BETWEEN': formula.NUMBER_BETWEEN,
    /**
     * 介于等于
     * @param a {string}
     * @param b {Array}
     * @return {boolean}
     */
    'BETWEEN_EQUAL': formula.NUMBER_BETWEEN_EQUAL,
    'ISNULL': formula.valueIsNull
  },
  'paas-percentage': {
    /**
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'EQUAL': formula.NUMBER_EQUAL,
    /**
     * 大于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'MORE_THAN': formula.NUMBER_MORE_THAN,
    /**
     * 大于等于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'NO_LESS_THAN': formula.NUMBER_NO_LESS_THAN,
    /**
     * 小于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'LESS_THAN': formula.NUMBER_LESS_THAN,
    /**
     * 小于等于
     * @param a {string}
     * @param b {string}
     * @return {boolean}
     */
    'NO_MORE_THAN': formula.NUMBER_NO_MORE_THAN,
    /**
     * 介于
     * @param a {string}
     * @param b {Array}
     * @return {boolean}
     */
    'BETWEEN': formula.NUMBER_BETWEEN,
    /**
     * 介于等于
     * @param a {string}
     * @param b {Array}
     * @return {boolean}
     */
    'BETWEEN_EQUAL': formula.NUMBER_BETWEEN_EQUAL,
    'ISNULL': formula.valueIsNull
  },
  'paas-date': {
    /**
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      return new Date(a).getTime() === new Date(b).getTime()
    },
    /**
     * 早于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'BEFORE': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() < new Date(b).getTime()
    },
    /**
     * 晚于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'AFTER': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() > new Date(b).getTime()
    },
    /**
     * 不早于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'NO_BEFORE': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() >= new Date(b).getTime()
    },
    /**
     * 不晚于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'NO_AFTER': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() <= new Date(b).getTime()
    },
    'ISNULL': formula.valueIsNull,
    /**
     * 介于等于
     * @param a {Date}
     * @param b {Array}
     * @return {boolean}
     */
    'DATE_BETWEEN_EQUAL': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() >= new Date(b[0]).getTime() && new Date(a).getTime() <= new Date(b[1]).getTime()
    }
  },
  'paas-dateTime': {
    /**
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      return new Date(a).getTime() === new Date(b).getTime()
    },
    /**
     * 早于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'BEFORE': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() < new Date(b).getTime()
    },
    /**
     * 晚于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'AFTER': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() > new Date(b).getTime()
    },
    /**
     * 不早于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'NO_BEFORE': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() >= new Date(b).getTime()
    },
    /**
     * 不晚于
     * @param a {Date}
     * @param b {Date}
     * @return {boolean}
     */
    'NO_AFTER': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() <= new Date(b).getTime()
    },
    'ISNULL': formula.valueIsNull,
    /**
     * 介于等于
     * @param a {Date}
     * @param b {Array}
     * @return {boolean}
     */
    'DATE_BETWEEN_EQUAL': function (a, b) {
      if (!a) return false
      return new Date(a).getTime() >= new Date(b[0]).getTime() && new Date(a).getTime() <= new Date(b[1]).getTime()
    }
  },
  'paas-personnel': {
    /**
     * @param a {Object}
     * @param b {Object, string, number}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      return (a && a.id) === Number(b)
    },
    /**
     * @param a {Array | Object}
     * @param b {Array}
     * @return {boolean}
     */
    'BELONG': function (a, b) {
      if (Array.isArray(a)) {
        const findLen = a.filter(item => b.find(i => i.id == item.id))
        return findLen.length === a.length
      } else {
        return !!(b.find(item => item.id == (a && a.id)))
      }
    },
    'NO_BELONG': function name (a, b) {
      if (Array.isArray(a)) {
        const findLen = a.filter(item => b.find(i => i.id == item.id))
        return !findLen.length
      } else {
        return !(b.find(item => item.id == (a && a.id)))
      }
    },
    'ISNULL': formula.valueIsNull
  },
  'paas-department': {
    /**
     * @param a {Object}
     * @param b {Object}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      return (a && a.id) === Number(b)
    },
    /**
     * @param a {Object}
     * @param b {Array[id]}
     * @return {boolean}
     * 属于和不属于都是多选
     */
    'BELONG': function (a, b) {
      if (!Array.isArray(b)) {
        b = [b]
      }
      return !!(b.find(item => item == (a && a.id)))
    },
    'NO_BELONG': function name (a, b) {
      if (!Array.isArray(b)) {
        b = [b]
      }
      return !(b.find(item => item == (a && a.id)))
    },
    /**
     * 归属
     * @param a {Array | Object}
     * @param b {Array}
     * @return {boolean}
     * 归属是单选
     */
    'BELONG_TO': function (a, b) {
      if (!b) return false
      return (a && a.code) && a.code !== b.toString() && a.code.indexOf(b) === 0
    },
    'ISNULL': formula.valueIsNull
  },
  'paas-region': {
    /**
     * @param a {Object}
     * @param b {Object}
     * @return {boolean}
     */
    'EQUAL': function (a, b) {
      return (a && a.townCode) === b
    },
    /**
     * 归属
     * @param a {Object}
     * @param b {string}
     * @return {boolean}
     */
    'REGION_BELONG_TO': function (a, b) {
      if (!b) return false
      const replace = str => str.replace(/(0+)$/g, '')
      const {cityCode, countyCode, provinceCode, townCode} = a || {}
      const codeA = replace(townCode || countyCode || cityCode || provinceCode || '')
      const codeB = replace(b)
      return codeA.indexOf(codeB) === 0
    },
    'ISNULL': formula.valueIsNull
  },
  'paas-masterDetailRelationship': {
    /**
     * @param a
     * @param b
     * @returns {boolean}
     * @constructor
     */
    'EQUAL': function (a, b) {
      return typeof a === 'object' ? a.id === b : a === b
    },
    'ISNULL': formula.valueIsNull
  },
  'paas-lookupRelationship': {
    /**
     * @param a
     * @param b
     * @returns {boolean}
     * @constructor
     */
    'EQUAL': function (a, b) {
      const value = lookupRelationship(a)
      return value === b
    },
    /**
     * @param a
     * @param b
     * @returns {boolean}
     * @constructor
     */
    'BELONG': function (a, b) {
      const value = lookupRelationship(a)
      return !!(b.find(v => v == value))
    },
    /**
     * @param a
     * @param b
     * @returns {boolean}
     * @constructor
     */
    'NO_BELONG': function (a, b) {
      const value = lookupRelationship(a)
      return formula.valueIsNull(value) || !(b.find(v => v == value))
    },
    'ISNULL': formula.valueIsNull
  }
}
